import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import type { CallbackItem } from '@/shared/constant/ResourceData';
import { ModelType } from '@tarslib/types/lib/common';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { CallbacksDetail } from './components/callbacks-detail/CallbacksDetail';
import { CallbacksList } from './components/callbacks-list/CallbacksList';

export function CallbacksInfo({ className }: { className?: string }) {
  const [callbackDetail, setCallbackDetail] = useState<{
    apiDetail?: CallbackItem;
    name?: string;
    open?: boolean;
  }>();
  const onCallbackSelect = useCallback((apiDetail: CallbackItem, name: string) => {
    setCallbackDetail({
      apiDetail,
      name,
      open: true,
    });
  }, []);
  const onDetailClose = useCallback(() => {
    setCallbackDetail({
      ...callbackDetail,
      open: false,
    });
  }, [callbackDetail]);

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const callbacks = useDocsDataModelStore((x) => {
    if (x.resourceData.type === ModelType.HttpApi) {
      return x.resourceData.extraData.callbacks;
    }
    return undefined;
  });

  return (
    callbacks &&
    Object.keys(callbacks).length > 0 && (
      <div className={clsx(className, 'mb-8')}>
        <h2 className="_response-title mb-4 text-xl font-600">
          {clientI18n('api.label.callbacks')}
        </h2>
        <CallbacksList data={callbacks} onSelect={onCallbackSelect} />
        <CallbacksDetail
          apiDetail={callbackDetail?.apiDetail}
          name={callbackDetail?.name}
          open={callbackDetail?.open}
          onClose={onDetailClose}
        />
      </div>
    )
  );
}
